import {
  Bot, Globe, Megaphone, ShieldCheck, Bell, MessageSquare, PhoneCall, Palette,
  HelpCircle, BookOpen, Mic, Sparkles, Rocket, Zap, Star, Settings, Wrench,
  Calendar, Mail, CreditCard, Users, BarChart,
  type LucideIcon,
} from "lucide-react";

// Enhancement card content now lives in the DB (platform_enhancements table,
// served from /api/platform/enhancements and /api/enhancements/upcoming).
// Icons are React components and can't be persisted, so cards store a string
// `iconKey` that we resolve here against this fixed registry.

export const ENHANCEMENT_ICONS: Record<string, LucideIcon> = {
  Bot,
  Globe,
  Megaphone,
  ShieldCheck,
  Bell,
  MessageSquare,
  PhoneCall,
  Palette,
  HelpCircle,
  BookOpen,
  Mic,
  Sparkles,
  Rocket,
  Zap,
  Star,
  Settings,
  Wrench,
  Calendar,
  Mail,
  CreditCard,
  Users,
  BarChart,
};

export const ENHANCEMENT_ICON_KEYS = Object.keys(ENHANCEMENT_ICONS);

export const DEFAULT_ENHANCEMENT_ICON_KEY = "BookOpen";

export function getEnhancementIcon(key: string | null | undefined): LucideIcon {
  if (key && ENHANCEMENT_ICONS[key]) return ENHANCEMENT_ICONS[key];
  return ENHANCEMENT_ICONS[DEFAULT_ENHANCEMENT_ICON_KEY];
}

// Shape returned by the platform CRUD endpoint.
export type PlatformEnhancement = {
  id: string;
  name: string;
  description: string;
  reenable: string;
  iconKey: string;
  status: "hidden" | "disabled";
  previewHref: string | null;
  note: string | null;
  showInWorkspaces: boolean;
  sortOrder: number;
  createdAt?: string | null;
  updatedAt?: string | null;
};

// Shape returned by the tenant-facing /api/enhancements/upcoming endpoint.
export type UpcomingEnhancement = {
  id: string;
  name: string;
  description: string;
  iconKey: string;
  previewHref: string | null;
  sortOrder: number;
};
